import { useStore } from '@/components/common/store';
import request from '../../common/services/request';
import type { BestAccommodationOfferForRegion } from '@/interfaces/api/v1-best-accommodation-offer-for-region';
import type { BestPackageOfferForRegion } from '@/interfaces/api/v1-best-package-offer-for-region';
import type { ApiDataTypesKeys } from '../../common/types';
import type { TravelType } from '@/interfaces/common';
import type { AxiosError } from 'axios';
import axios from 'axios';
const store = useStore();
const regionListUrl = '/v1/best-offer-for-region';
const apiData = store.getters['searchMask/apiData'];

const loading = { value: false };
const error = { value: null };
const items = { value: [] };

export const fetchItems = async (
	isOnlyHotel: boolean,
	bodyParamsValues: { displaymode: string; countryCode: string; rlId: string }
): Promise<{
	data: null | BestAccommodationOfferForRegion[] | BestPackageOfferForRegion[];
	loading: boolean;
	error: AxiosError | null;
}> => {
	const travelType = isOnlyHotel ? 'Accommodation' : 'Package';
	const exclude: ApiDataTypesKeys[] = travelType === 'Accommodation' ? ['DepartureAirport', 'DirectFlight', 'Transfer'] : [];
	exclude.push('DefiniteStartDate', 'SortOrder', 'HotelIffCode', 'DealsOnly');

	const bodyParams = {
		travelType: travelType as TravelType,
		locationId: bodyParamsValues.displaymode === 'country' ? [bodyParamsValues.countryCode] : [],
		regionGroupIds: bodyParamsValues.displaymode === 'regiongroup' ? [parseInt(bodyParamsValues.rlId, 10)] : [],
	};

	const body = apiData(bodyParams, exclude);
	const uri = regionListUrl;

	loading.value = true;

	return request<BestAccommodationOfferForRegion | BestPackageOfferForRegion>({ url: uri, data: body }, 'regionListOffers')
		.then((resp) => {
			error.value = null;
			loading.value = false;
			return { data: Array.isArray(resp) ? resp : [resp], loading: loading.value, error: error.value };
		})
		.catch((axiosError: AxiosError) => {
			if (axios.isCancel(axiosError)) {
				loading.value = true;
				return { data: null, loading: loading.value, error: error.value };
			}

			const { response } = axiosError as AxiosError;
			if (response && response.status >= 500) {
				error.value = axiosError;
			} else {
				items.value = [];
			}

			loading.value = false;
			return { data: null, loading: loading.value, error: error.value };
		});
};
